<template>
    <section class="probootstrap-section">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center" v-if="type===1">
                    <h4>各行各业都有解决方案</h4>
                    <p>全国独家既能连接心泰健康APP，更能参与301医院心脏健康管理服务</p>
                </div>

                <div class="col-md-12 text-center" v-else>
                    <h4>应用场景</h4>
                    <p>智能穿戴设备监测生命体征指标，结合AI健康算法分析心脏健康风险、301医院医疗专家制定心脑血管风险评估体系，心泰健康管理系统数字化支持健康管理服务功能。</p>
                </div>
            </div>
        </div>
        <div class="container containerTop">
            <div class="row">
                <div class="col-md-12 flex">
                    <div class="bgImg1">
                        <a href="/endowment">
                            <img class="bgImg" :src="require('../assets/scenarios/scenarios1.png')" >
                            <h3>智慧养老</h3>
                            <img class="ImgIcon" src="../assets/home/img14.png"></a>
                    </div>
                    <div class="bgImg1">
                        <a href="/medical">
                            <img class="bgImg"  :src="require('../assets/scenarios/scenarios2.png')">
                            <h3>医疗健康</h3>
                            <img class="ImgIcon" src="../assets/home/img14.png">
                        </a>
                    </div>
                    <div class="bgImg1">
                        <a href="https://www.colofoo.com/fire.html" target="_blank">
                            <img class="bgImg"  :src="require('../assets/scenarios/scenarios5.png')">
                            <h3>部队、消防<br/>
                                安全监测</h3>
                            <img class="ImgIcon" src="../assets/home/img14.png"></a>
                    </div>
                    <div class="bgImg1">
                        <a href="https://www.colofoo.com/bus.html" target="_blank">
                            <img class="bgImg"  :src="require('../assets/scenarios/scenarios4.png')">
                            <h3>交通行业</h3>
                            <img class="ImgIcon" src="../assets/home/img14.png"></a>
                    </div>
                    <div class="bgImg1">
                        <a href="https://www.colofoo.com/pharmacy.html" target="_blank">
                            <img class="bgImg"  :src="require('../assets/scenarios/scenarios3.png')">
                            <h3>诊所药店</h3>
                            <img class="ImgIcon" src="../assets/home/img14.png"></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "scenarios",
        props:{type:Number},
        methods:{
            
        }
    }
</script>

<style scoped>
    .containerTop{
        margin-top: 20px;
    }
    .containerTop .row{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .flex {
        width: 100%;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }

    .flex div {
        width: 30%;
        /* background: #000; */
        height: 240px;
        background-size: contain;
        position: relative;
        margin: 0 10px 20px 0;
        /*border: 1px solid;*/
    }
    .flex div:nth-child(1),.flex div:nth-child(2){
        width: 45%;
    }
    .flex div .bgImg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        /* left: 20px; */
        bottom: 0;
        z-index: 0;
        object-fit: contain;
        width: 100%;
        height: 100%;
    }

    .flex div img:last-child {
        height: 28px;
        position: absolute;
        left: 50px;
        bottom: 46px;
        z-index: 1;
        border-radius: 50%;
        border: 1px solid #ffffff;
    }
    .bgImg1 {
        width: 30%;
    }
    .bgImg1 h3 {
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 37px;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.6);
        position: absolute;
        left: 50px;
        bottom: 100px;
        z-index: 1;
        background: transparent;
        cursor: pointer;
    }

    .bgImg1:hover .bgImg {
        /* box-shadow: 0 0 010px 6px rgba(0, 0, 0, .4); */
    }
</style>
